"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 接口模块
var _default = exports.default = {
  getInterfaceList: function getInterfaceList(data, cancelToken) {
    return (0, _request.default)({
      url: '/protected/interface/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getInterfaceDetail: function getInterfaceDetail(id) {
    return (0, _request.default)({
      url: '/protected/interface/query/' + id,
      method: 'get'
    });
  },
  saveInterface: function saveInterface(data) {
    return (0, _request.default)({
      url: '/protected/interface/save',
      method: 'post',
      data: data
    });
  },
  deleteInterface: function deleteInterface(data) {
    return (0, _request.default)({
      url: '/protected/interface/delete',
      method: 'post',
      data: data
    });
  },
  enableInterface: function enableInterface(id) {
    return (0, _request.default)({
      url: '/protected/interface/enable/' + id,
      method: 'get'
    });
  },
  disabledInterface: function disabledInterface(id) {
    return (0, _request.default)({
      url: '/protected/interface/disabled/' + id,
      method: 'get'
    });
  }
};